/**
 * Font sizes (in px) for text rendered inside MaterialReactTable instances —
 * about 11% larger than the equivalent `OpenSans`/`Mono` `size` scale used
 * elsewhere in the app. Pass these as the numeric `size` prop, e.g.
 * `<OpenSans.Primary size={TableTextSize.s}>`.
 */
export const TableTextSize = {
  xs: 14, // was 12 (xs-12 / s-12)
  s14: 15, // was 14 (s-14)
  s: 17, // was 16 (s-16)
  m: 20, // was 18 (m-18, the OpenSans/Mono default when no size is given)
  l: 23, // was 20 (l-20)
  xl: 30, // was 28 (xl-28)
} as const;
